module.exports = __webpack_public_path__ + "img/project4_9.jpg.d04b9258.webp";